import { CreateLoaderTable } from "@/components/Loaders";
import { Main } from "@/components/Main";
import { useEffect, useState } from "react";
import { TableData } from "@/App/Distributions/SellerToSeller/TableSimplified";
import { useAuth } from "@/hooks/auth";
import { getContestssData } from "@/Api/contests";
import { useNavigate } from "react-router-dom";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogAction,
} from "@/components/ui/alert-dialog";
import { colors } from "@/utils/colors";
import { cn } from "@/lib/utils";

export default function SellerToSellerDistributions() {
  const [state, setState] = useState<"loading" | "production" | "error">(
    "loading"
  );
  const [dataApi, setDataApi] = useState<any>(null);
  const [showAccessDialog, setShowAccessDialog] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.user_type_id !== 3) {
      setShowAccessDialog(true);
    }
  }, [user]);

  const fetchData = async (page: number = 1) => {
    try {
      setState("loading");
      // Buscar concursos ativos (status 1)
      const { data } = await getContestssData(page, { contest_status_id: 1, is_active: 1});

      if (data?.status) {
        setDataApi(data.response);
        setState("production");
      } else {
        setState("error");
      }
    } catch (error) {
      console.error(error);
      setState("error");
    }
  };

  useEffect(() => {
    if (user?.user_type_id === 3) {
      fetchData();
    }
  }, [user]);

  const pageActions = {
    update: async () => {
      await fetchData(dataApi?.current_page || 1);
    },
    next: async () => {
      if (dataApi?.current_page < dataApi?.last_page) {
        await fetchData(dataApi.current_page + 1);
      }
    },
    previous: async () => {
      if (dataApi?.current_page > 1) {
        await fetchData(dataApi.current_page - 1);
      }
    },
    lastPage: async () => {
      if (dataApi?.current_page !== dataApi?.last_page) {
        await fetchData(dataApi.last_page);
      }
    },
  };

  const handleAccessDialogClose = () => {
    setShowAccessDialog(false);
    navigate("/");
  };

  return (
    <Main>
      <div className="flex justify-center md:justify-between items-center flex-wrap gap-2">
        <h2 className="text-2xl font-semibold flex gap-2 items-center">
          Distribuições Entre Vendedores
        </h2>
      </div>
      <div className="flex flex-col gap-3">
        {state === "loading" ? (
          <CreateLoaderTable cols={4} lines={6} />
        ) : (
          <TableData dataApi={dataApi} pageActions={pageActions} />
        )}
      </div>

      <AlertDialog open={showAccessDialog} onOpenChange={setShowAccessDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Acesso Negado</AlertDialogTitle>
            <AlertDialogDescription>
              Esta funcionalidade está disponível apenas para usuários do tipo
              Vendedor. Seu tipo de usuário atual não tem permissão para acessar
              as distribuições entre vendedores.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogAction
              onClick={handleAccessDialogClose}
              className={cn(colors.bg_primary)}
            >
              Entendi
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </Main>
  );
}